// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3ePyh","dragIcon":"SortableItem_dragIcon__Vi0v7","disabled":"SortableItem_disabled__3E8pZ"};